import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalQPage10, { ICustomProps } from './index';
import { InputFieldConfig } from '../../../../types';

const mapStateToProps = (state: ApplicationState): ICustomProps => {
  const {
    WhatsApp: whatsAppConfig,
    WhatsAppPhoneNumber: whatsAppPhoneNumberConfig,
  }: {
    WhatsApp: InputFieldConfig;
    WhatsAppPhoneNumber: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page10;

  const { useWhatsapp = '', whatsAppPhoneNumber = '' } = state.student.personalInfo;

  const whatsAppVisible = true;
  const whatsAppPhoneNumberVisible = useWhatsapp === 'Different';

  const whatsAppMandatory = true;
  const whatsAppPhoneNumberMandatory = true;

  // prettier-ignore
  const complete =
    (!whatsAppVisible || !whatsAppMandatory || useWhatsapp !== '') &&
    (!whatsAppPhoneNumberVisible ||
      !whatsAppPhoneNumberMandatory ||
      whatsAppPhoneNumber !== '');

  return {
    sectionTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    complete,
    currentStep: 10,
    steps: 10,
    useWhatsapp,
    whatsAppVisible,
    whatsAppConfig,
    whatsAppPhoneNumber,
    whatsAppPhoneNumberVisible,
    whatsAppPhoneNumberConfig,
    config: state.student.config,
  };
};

export default connect(mapStateToProps)(PersonalQPage10);
